document.addEventListener('DOMContentLoaded', function () {
  const FORM_ID =
    'featured-product-form-template--23884875071762__featured_product_kR3fJL';

  function hideBuyNow() {
    const form = document.getElementById(FORM_ID);
    if (!form) return;

    const paymentButton = form.querySelector(
      '.shopify-payment-button'
    );

    if (!paymentButton) return;

    paymentButton.style.display = 'none';
    paymentButton.setAttribute('aria-hidden', 'true');

    /*
     * Shopify can sometimes put the actual button back to visible
     * even though the parent is supposed to be hidden.
     */
    const actualButton = paymentButton.querySelector(
      '.shopify-payment-button__button'
    );

    if (actualButton) {
      actualButton.style.display = 'none';
    }
  }

  // Initial state
  hideBuyNow();

  /*
   * Shopify may rebuild the accelerated checkout button after
   * variant/quantity changes, so watch this specific form.
   */
  const form = document.getElementById(FORM_ID);

  if (form) {
    const observer = new MutationObserver(function () {
      hideBuyNow();
    });

    observer.observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }
});
